// import DataTable from '@/containers/data_table_ml/DataTable';
import { history, useLocation } from 'umi';
import React, { useState } from 'react';
import { useDispatch } from 'dva';
import qs from 'qs';
import dayjs from 'dayjs';
import { useIntl } from 'umi';
// import editImg from '@/assets/img/edit.png';
// import detail from '@/assets/img/detail.png';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import webStorage from '@/utils/storageManager';
import TablePageStyled from './TablePageStyled.jsx';
import { fmtThousand } from '@/utils/comUtil';

const TablePage = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const location = useLocation();
  const { query, pathname } = location;
  //礼品状态
  const ACTIVITY_POINTS_GIFT_STATUS =
    webStorage.get('DICTOBJ')?.ACTIVITY_POINTS_GIFT_STATUS;
  //礼品类别
  const ACTIVITY_POINTS_GIFT_TYPE =
    webStorage.get('DICTOBJ')?.ACTIVITY_POINTS_GIFT_TYPE?.map((item) => ({
      ...item,
      nameZh: item.nameZh === '实物' ? '实物邮寄' : item.nameZh,
    })) || [];
  const theme = useTheme();
  const dispatch = useDispatch();
  //关于弹窗
  const [openDialog, setOPenDialog] = useState(false);
  const handleCloseDialog = () => {
    setOPenDialog(false);
  };
  // const [rowData, setRowData] = useState();
  const [dialogInfo, setDialogInfo] = useState({
    title: '',
    content: '',
    onConfirm: () => {},
  });
  const handleDeleteGood = (id) => {
    dispatch({
      type: 'giftManagement/deleteGift',
      payload: {
        values: {
          id: id,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          setOPenDialog(false);
          window.message.toast({
            type: 'success',
            message: '删除礼品成功',
            title: '成功',
          });
          const refreshTime = dayjs().format('YYYY-MM-DD :HH-mm-ss');
          history.replace(
            `${pathname}?${qs.stringify({
              ...query,
              refreshTime,
            })}`,
          );
        }
      },
    });
  };

  const { pagination, total, loading, tableData, setPageData } = props || {};
  const handleToGoodDetail = (record, status, sourceOid) => {
    history.push({
      pathname:
        status === 'edit'
          ? '/integral/gift_management/management_gift_form_edit'
          : '/integral/gift_management/management_gift_form_detail',
      query: {
        opt: status === 'edit' ? 'edit' : 'detail',
        id: String(record.id),
        sourceOid,
      },
    });
  };

  const columns = [
    {
      align: 'center',
      title: '礼品code',
      width: 200,
      id: 'code',
      key: 'code',
    },
    {
      title: formatMessage({ id: 'item.gift.c01.lbl02' }),
      align: 'center',
      id: 'title',
      key: 'title',
      width: 140,
    },
    {
      title: '礼品类型',
      id: 'type',
      key: 'type',
      width: 100,
      align: 'center',
      render: ({ type }) => {
        return ACTIVITY_POINTS_GIFT_TYPE?.find((i) => i.nameEn === type)
          ?.nameZh;
      },
    },
    {
      title: '兑换积分',
      id: 'points',
      key: 'points',
      width: 140,
      align: 'center',
    },
    {
      title: '兑换金额',
      id: 'cost',
      key: 'cost',
      width: 140,
      align: 'center',
      render: (item) => {
        return item.cost !== null ? fmtThousand(item.cost, 2, true) : '-';
      },
    },
    {
      title: '剩余库存',
      id: 'surplusStock',
      key: 'surplusStock',
      width: 140,
      align: 'center',
      render: (item) => {
        return (
          <span textAlign="center">
            {item.surplusStock !== null
              ? fmtThousand(item.surplusStock, 0)
              : ''}
            /{item.stock !== null ? fmtThousand(item.stock, 0) : ''}
          </span>
        );
      },
    },
    {
      title: formatMessage({ id: 'item.gift.c01.lbl10' }),
      id: 'status',
      key: 'status',
      width: 140,
      align: 'center',
      render: ({ status }) => {
        return ACTIVITY_POINTS_GIFT_STATUS?.find((i) => i.nameEn === status)
          ?.nameZh;
      },
    },
    {
      title: '有效期',
      id: 'expirationDate',
      key: 'expirationDate',
      width: 260,
      align: 'center',
    },
    {
      title: '更新时间',
      id: 'updateDate',
      key: 'updateDate',
      width: 220,
      align: 'center',
    },
    {
      title: formatMessage({ id: 'item.gift.c01.lbl11' }),
      width: 200,
      align: 'center',
      render: (recor) => {
        // const canDelete = !recor.hasExchange; //可以删除
        const canEdit = recor.status !== 'INVALID'; //可以编辑
        return (
          <div align="center" className={'handle_btn'}>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_point_mall_gift_management_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    gift_id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() =>
                  handleToGoodDetail(
                    recor,
                    'edit',
                    'btn_point_mall_gift_management_list_edit',
                  )
                }
                disabled={!canEdit}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={
                    canEdit
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.05' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_point_mall_gift_management_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    gift_id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                className=""
                onClick={() =>
                  handleToGoodDetail(
                    recor,
                    'detail',
                    'btn_point_mall_gift_management_list_details',
                  )
                }
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.04' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_point_mall_gift_management_list_delete',
                  events: ['_ev', '_ec'],
                  params: {
                    gift_id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  dispatch({
                    type: 'giftManagement/canDeleteGift',
                    payload: {
                      values: {
                        giftId: recor.id,
                      },
                    },
                    callback: (res) => {
                      if (!res?.data?.hanExChange) {
                        setDialogInfo({
                          title: formatMessage({ id: 'comm.action.btn.04' }),
                          content: formatMessage({ id: 'item.gift.d02.txt01' }),
                          rowData: recor,
                          onConfirm: () => {
                            handleDeleteGood(recor.id);
                          },
                        });
                      } else {
                        setDialogInfo({
                          title: formatMessage({ id: 'comm.action.btn.04' }),
                          content: '抱歉，已被兑换过的礼品需要留档，不可删除',
                          rowData: recor,
                          onConfirm: () => {
                            setOPenDialog(false);
                          },
                        });
                      }
                      setOPenDialog(true);
                    },
                  });
                }}
              >
                <SvgIconML
                  name="circleDelete"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];
  return (
    <TablePageStyled>
      <DataTableNativeML
        loading={loading}
        paging={true}
        total={total}
        columns={columns}
        page={pagination}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={tableData}
        columnKey="id"
      ></DataTableNativeML>

      <DialogDataML
        open={openDialog}
        title={dialogInfo.title}
        content={dialogInfo.content}
        handleClose={handleCloseDialog}
        handleConfirm={dialogInfo.onConfirm}
      ></DialogDataML>
    </TablePageStyled>
  );
};
export default TablePage;
